var React = require('react');

function ArrowTop (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"m1.25 8.5 7.5-7.25 7.5 7.25M8.75 23.5V1.25"})));
}

ArrowTop.defaultProps = {"width":"17.5","height":"24.75","data-name":"Layer 1","viewBox":"0 0 17.5 24.75"};

module.exports = ArrowTop;

ArrowTop.default = ArrowTop;
